import { useQuery } from '@tanstack/react-query';
import { walletService } from '../services/wallet.service';
import type { TransactionFilters } from '../types/wallet.types';

export function useTransactions(filters?: TransactionFilters) {
  return useQuery({
    queryKey: ['transactions', filters],
    queryFn: () => walletService.getTransactions(filters),
  });
}
